module.exports = __webpack_public_path__ + "static/media/img118.cb9c9a37.jpg";